import { ConstantsOpenPose } from '../constants_open_pose';

export function is_match_bone_prefix(name: string) {
  if (name.startsWith(ConstantsOpenPose.MODEL_INFO_HAND.bone_prefix)) return true;
  if (name.startsWith(ConstantsOpenPose.MODEL_INFO_FOOT.bone_prefix)) return true;

  return false;
}
